import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import "@/assets/scss/app.scss";
import store from "./store";
import Breadcrumbs from "./components/bread_crumbs";
import VueApexCharts from "vue3-apexcharts";
// import "bootstrap";
import settingPage from "./components/settingPage.vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "brackets-viewer/dist/brackets-viewer.min.css";
import bcard from "./components/b-card.vue";
import VeeValidatePlugin from "./includes/validation";

// form builder
import ElementPlus from "element-plus";
import "element-plus/theme-chalk/index.css";
import SvgIcon from "@/form_builder/components/form/SvgIcon/index.vue";
import { VueDraggableNext } from "vue-draggable-next";
import DraggableWarp from "@/form_builder/components/form/DraggableWarp.vue";
import OptionInput from "@/form_builder/components/form/OptionInput.vue";
import UploadWarp from "@/form_builder/components/form/elementWarp/UploadWarp.vue";

import es from "element-plus/es/locale/lang/es";
import hljs from "highlight.js";
import "highlight.js/styles/googlecode.css";

// specific src
import Vue3Toasity from "@/includes/toast.conf";
import PrimeVue from "primevue/config";
import "primevue/resources/themes/saga-blue/theme.css";
import "primeicons/primeicons.css";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Tree from "primevue/tree";
import Panel from "primevue/panel";
import Card from "primevue/card";
import Avatar from "primevue/avatar";
import Chip from "primevue/chip";
import Tag from "primevue/tag";
import FileUpload from "primevue/fileupload";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup"; // optional
import Row from "primevue/row"; // optional
import Menu from "primevue/menu";
import ProgressSpinner from "primevue/progressspinner";
import ConfirmDialog from "primevue/confirmdialog";
import DynamicDialog from "primevue/dynamicdialog";
import EmptyState from "./components/emptyState.vue";
import axiosInstance from "./includes/fileconnection";

const app = createApp(App);
app.config.globalProperties.$axios = axiosInstance;

app.use(ElementPlus, {
  locale: es,
});
app.component("draggable", VueDraggableNext);
app.component("draggable-warp", DraggableWarp);
app.component("option-input", OptionInput);
app.component("svg-icon", SvgIcon);
app.component("upload-warp", UploadWarp);

app.directive("highlight", function (el) {
  let blocks = el.querySelectorAll("pre code");
  setTimeout(() => {
    blocks.forEach((block) => {
      hljs.highlightBlock(block);
    });
  }, 200);
});

app
  .use(VeeValidatePlugin)
  .use(PrimeVue)
  .component("Button", Button)
  .component("Dialog", Dialog)
  .component("Panel", Panel)
  .component("Card", Tree)
  .component("Avatar", Tree)
  .component("InputText", InputText)
  .component("Dropdown", Dropdown)
  .component("FileUpload", FileUpload)
  .component("DataTable", DataTable)
  .component("Column", Column)
  .component("ColumnGroup", ColumnGroup)
  .component("Row", Row)
  .component("Tree", Tree) //
  .component("Menu", Menu)
  .component("ProgressSpinner", ProgressSpinner)
  .component("ConfirmDialog", ProgressSpinner)
  .component("DynamicDialog", DynamicDialog)
  .use(store)
  .use(VueSweetalert2)
  .use(router)
  .use(Vue3Toasity)
  .use(require("vue-chartist"))
  .component("settingPage", settingPage)
  .component("b-card", bcard)
  .component("Breadcrumbs", Breadcrumbs)
  .component("apexchart", VueApexCharts)
  .component("EmptyState", EmptyState)
  .mount("#app");
